module.exports = "<p>\n  stock-transfer-in-approve works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/view/transactions/t-stock-transfer-in-approve/t-stock-transfer-in-approve.component.html
// module id = ./src/app/view/transactions/t-stock-transfer-in-approve/t-stock-transfer-in-approve.component.html
// module chunks = main